// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lTOrYy {
  width: 100%;
  background: var(--surface-neutral-pale);
  padding: var(--spacing-1) var(--spacing-1-5);
  border: var(--border-width-1, 1px) solid var(--surface-neutral-silver);
  border-radius: var(--radius-s);
  margin-bottom: var(--spacing-3);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}
.H2KhNn {
  flex: 0 0 auto;
}
.POlv3_ {
  border: none;
  background: transparent;
  font-size: var(--font-size-md, 14px);
  color: var(--text-neutral-stronger);
  outline: none;
  flex: 1 1 auto;
  min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/SearchBar/SearchBar.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uCAAuC;EACvC,4CAA4C;EAC5C,sEAAsE;EACtE,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;EACnC,aAAa;EACb,cAAc;EACd,YAAY;AACd","sourcesContent":[".container {\n  width: 100%;\n  background: var(--surface-neutral-pale);\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border: var(--border-width-1, 1px) solid var(--surface-neutral-silver);\n  border-radius: var(--radius-s);\n  margin-bottom: var(--spacing-3);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n.searchIcon {\n  flex: 0 0 auto;\n}\n.input {\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-md, 14px);\n  color: var(--text-neutral-stronger);\n  outline: none;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `lTOrYy`,
	"searchIcon": `H2KhNn`,
	"input": `POlv3_`
};
module.exports = ___CSS_LOADER_EXPORT___;
